import { render, staticRenderFns } from "./GroupCreate.vue?vue&type=template&id=2f51c99e&scoped=true&"
import script from "./GroupCreate.vue?vue&type=script&lang=js&"
export * from "./GroupCreate.vue?vue&type=script&lang=js&"
import style0 from "./GroupCreate.vue?vue&type=style&index=0&id=2f51c99e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f51c99e",
  null
  
)

export default component.exports